//------------------------------------------------------------------------
// Terms & Topics expand toggle
//------------------------------------------------------------------------
import ExpandToggle from "@threespot/expand-toggle";

document.querySelectorAll('.TermsTopics-button[data-expands]').forEach(el => {
  const toggle = new ExpandToggle(el);
});
